import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { TradeTypeEnum } from "@/types/FmsEnums";
import { formatLocalDateTime } from "@/utils/utils";
import { InvoiceBill } from "@/views/invoice/manage/InvoiceManageTypes";
import { invoiceModel } from "@/views/invoice/manage/InvoiceModel";
import { recordModel } from "./recordModel";
import TextPriviewImage from "@/components/Custom/TextPriviewImage";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export function DataTable() {

    const { imageUrl } = invoiceModel();
    const { dataSource, pgCfg, loadData } = recordModel();

    const columns: ColumnsType<InvoiceBill> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 50,
            ellipsis: true,
            align: "center",
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            align: "center",
            width: 150,
        },
        {
            title: '收款状态',
            dataIndex: 'status',
            align: "center",
            width: 50,
            render: (v) => v === 0 ? '初始' : v === 1 ? '已记账' : v === 2 ? '已核销' : ''
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceTypeCode',
            align: "center",
            width: 80,
            render: (v: any, r: any, i: number) =>
                v == 'invoice-type.no' ? '无票' :
                    v == 'invoice-type.vat-ordinary' ? '增值税普通发票' :
                        v == 'invoice-type.vat-special' ? '增值税专用发票' : '',
        },
        {
            title: '开票状态',
            dataIndex: 'invoiceStatus',
            align: "center",
            width: 50,
            render: (v) => v === 0 ? '未开票' : v === 1 ? '已开票' : ''
        },
        {
            title: '发票编号',
            dataIndex: 'invoiceNum',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (text, record) => {
                return (
                    <TextPriviewImage text={text} previewList={record.invoiceMd5?.split(",")} imageUrl={imageUrl} />
                )
            },
        },
        {
            title: '上传日期',
            dataIndex: 'invoiceUploadTime',
            align: "center",
            width: 100,
            render: (e => formatLocalDateTime(e))
        },
        {
            title: '发票日期',
            dataIndex: 'invoiceTime',
            align: "center",
            width: 100,
        }
    ];

    useEffect(() => {
        loadData().then();
    }, [])

    return (
        <Table
            rowKey={record => record.key}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}

